import React from "react";
import { useEffect, useRef } from "react";
import { useState } from "react";

const useOnScreen = (ref) => {
  const [isIntersecting, setIntersecting] = useState(false);
  let observer = false;
  try {
    observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIntersecting(entry.isIntersecting),
      {
        root: null,
        threshold: 0,
        trackVisibility: true,
        delay: 100,
      }
    );
  } catch (error) {
    console.log("intersection Observer is not defined in this browser", error);
  }

  useEffect(() => {
    try {
      observer.observe(ref.current);
      // Remove the observer as soon as the component is unmounted
      return () => {
        observer.disconnect();
      };
    } catch {
      setIntersecting(true);
    }
  }, []);

  return isIntersecting;
};

function OnScreenWrapper({ children, styleFunction }) {
  const ref = useRef(null);
  const bool = ref && useOnScreen(ref);
  return (
    <div ref={ref} style={styleFunction && styleFunction(bool)}>
      {bool ? children : ""}
    </div>
  );
}

export { useOnScreen, OnScreenWrapper };
